import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";
import { FulfillmentStateIcon } from "@/services/backend/relationships/components/fulfillment-state-icon";
import t from "@/lang/lang";

export function FulfillmentStateBadge({ state }: { state: FulfillmentState }) {
  return (
    <div className="flex items-center gap-2">
      <FulfillmentStateIcon state={state} disableTooltip />
      <span className="text-sm font-medium">{t(state)}</span>
    </div>
  );
}
